export const DEFAULT_ARTICLE_LAYOUT_NAME = 'modern_layout'
export const MEDUSA_ARTICLE_LAYOUT_NAME = 'medusa_layout'

export const BLOG_ARTICLE_LAYOUT_NAMES = {
  default: DEFAULT_ARTICLE_LAYOUT_NAME,
  medusa: MEDUSA_ARTICLE_LAYOUT_NAME,
}
